import { ThunkAction } from 'redux-thunk';
import * as Actions from './actions';
import * as UserActions from '../user/actions';
import { AnyAction } from 'redux';
import { AppState } from '../../store';
import AuthService from '../../../utils/BkpAuthService';
import { setCookie } from '../../utils/cookie';

export const submitCode = (code: string): ThunkAction<Promise<void>, AppState, {}, AnyAction> => async (
  dispatch,
  getState
) => {
  dispatch(Actions.submitCode(code));
  const { email, password, signupSessionId, phoneNumber } = getState().signUpForm;

  try {
    const data = await AuthService.verifyPasscode(signupSessionId, code, password.value);

    setCookie('access_token', data.accessToken);
    setCookie('refresh_token', data.refreshToken);
    setCookie('user_id', data.userId);
    setCookie('email', email.value);
    setCookie('phone_number', phoneNumber.value);

    // 成功を受けて画面遷移するため、ユーザー情報を先に入れておく
    dispatch(UserActions.setEmail(email.value));
    dispatch(UserActions.setPhoneNumber(phoneNumber.value));
    dispatch(UserActions.setAccessToken(data.accessToken));
    dispatch(UserActions.setUserId(data.userId));
    dispatch(UserActions.setRefreshToken(data.refreshToken));

    dispatch(Actions.submitSuccess(data.accessToken, data.refreshToken, data.userId, email.value, phoneNumber.value));
  } catch (error) {
    console.error(error);
    dispatch(Actions.submitFailed());
  }
};
